import { render, staticRenderFns } from "./accordionItemComponent.vue?vue&type=template&id=2fcb64c2&scoped=true"
import script from "./accordionItemComponent.vue?vue&type=script&lang=js"
export * from "./accordionItemComponent.vue?vue&type=script&lang=js"
import style0 from "./accordionItemComponent.vue?vue&type=style&index=0&id=2fcb64c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcb64c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fcb64c2')) {
      api.createRecord('2fcb64c2', component.options)
    } else {
      api.reload('2fcb64c2', component.options)
    }
    module.hot.accept("./accordionItemComponent.vue?vue&type=template&id=2fcb64c2&scoped=true", function () {
      api.rerender('2fcb64c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/accordion/accordionItemComponent.vue"
export default component.exports